<div dialog-header>
  <h4>Forgot Username?</h4>
  <button class="close-btn" (click)="close()">
    <app-icon name="cross" width="16px" height="16px" />
  </button>
</div>

@if (processing()) {
  <app-spinner />
} @else {
  @if (!emailSuccess()) {
    <form [formGroup]="usernameForm">
      <app-input-control label="Email Address" formControlName="email" type="email" />
      <app-recaptcha (resolved)="onCaptchaResolved($event)" />
    </form>
  } @else {
    <p class="success-text">Your username has been sent to your email!</p>
  }
}

<div dialog-actions>
  @if (!emailSuccess()) {
    <button ui-button (click)="forgotUsername()" [disabled]="usernameForm.invalid">Send Username</button>
    <button ui-button type="danger" (click)="close()">Cancel</button>
  } @else {
    <button ui-button (click)="close()">Continue</button>
  }
</div>
